import { customerMemory } from "../../Objects/Memory/Memory"
import { CustomerEntity } from "../../Objects/Customer/CustomerEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"

export const useGetCustomer = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetCostumer = async (onSuccess: any) => {
    enableLoad()
    try {
      const response = await GetRequest<CustomerEntity[]>(API_ROUTES.CUSTOMER.GET_ALL)

      if (response.success) {
        const temp = response.data?.map((ss) => new CustomerEntity(ss)) ?? []

        customerMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleCheckIfHasCustomer = async (identify: string, onSuccess: any, rote: string = "") => {
    enableLoad()

    try {
      const params = new URLSearchParams()

      params.append("filter", identify)

      const response = await GetRequest<boolean>(`${rote}?${params.toString()}`)

      if (response.success) {
        onSuccess(response.data)

        return
      }

      onSuccess(false)

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetCostumer,
    handleCheckIfHasCustomer,
  }
}
